<template>
	<div id="page-wrapper">
		<div class="row page-titles">
			<div class="col-md-5 align-self-center">
				<h3 class="text-themecolor">{{ $t('nav.blog') }}</h3>
			</div>
			<div class="col-md-7 align-self-center">
				<ol class="breadcrumb">
					<li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
					<li class="breadcrumb-item active">{{ $t('nav.blog') }}</li>
				</ol>
			</div>
		</div>
		<div class="container-fluid">
			<!-- /row -->
			<div class="row">
				<div class="col-md-12 col-sm-12">
					<div class="card">
						<div class="card-header">
							<div class="pull-right">
								<el-button type="primary" size="small" round @click="newBlog">{{ $t('website.blog.new') }}</el-button>
							</div>
							<h4>
								<el-date-picker
							      v-model="dateRange"
							      slot="prepend"
							      type="daterange"
							      value-format="yyyy-MM-dd"
							      :range-separator="$t('contract.to')"
							      :start-placeholder="$t('contract.start-date')"
							      :end-placeholder="$t('contract.end-date')"
							      >
							    </el-date-picker>
							</h4>
						</div>
						<div class="card-body">
						  <ul class="list">
						    <BlogBox :blog="v" v-for="v in data" />
						  </ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped>
</style>
<script>
import BlogBox from '@/components/website/BlogBox.vue'
import moment from 'moment'

export default {
  name: 'Schedule',
  components: {
    BlogBox
  },
  data: function() {
	return {
      data: null,
      dateRange: [moment().startOf('year').format('YYYY-MM-DD'), moment().endOf('year').format('YYYY-MM-DD')]
	}
  },
  watch: {
    
  },
  methods: {
    newBlog: function() {
      this.$router.push({ path: '/blog/new' })
    },
    loadData: function() {
      let that = this,
          userId = localStorage.getItem('token')
	  this.$http.get(this.API3_PREFIX + 'blogs?userId=' + userId).then(function (response) {
		that.data = response.data
      }).catch(function (error) {
		console.log(error)
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>